// extracted by mini-css-extract-plugin
export var box = "_60-1";
export var checkboxRow = "_60-8";
export var checked = "_60-2";
export var descriptionSpacer = "_60-a";
export var disabled = "_60-3";
export var icon = "_60-6";
export var input = "_60-0";
export var labelSpacer = "_60-9";
export var medium = "_60-5";
export var small = "_60-4";
export var text = "_60-7";